/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon16Light = forwardRef('UiMenuDots3HIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z" }),
        React.createElement("path", { d: "M8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" }),
        React.createElement("path", { d: "M12 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" })));
});
